import React, { useState } from 'react'
import { mTheme } from '../../../style/themes'
import { css } from '@emotion/react'

import { useOnUserSubmit } from '../SignupUtils'
import Button from '../../../components/Button'

import useUserSignup from './useUserSignupState'
import UserSignupFields from './UserSignupFields'

import { Link } from '@remix-run/react'
import { Page } from '../../../components/Page/Page'
import { Card } from '../../../components/Card/Card'

const styles: Styles = {
  form: css({
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: mTheme.size.S,
  }),

  signupButton: css({
    width: '100%',
    marginBottom: 0,
  }),
  footnote: css({
    textAlign: 'left',
    fontSize: mTheme.fontSize.S,
    [mTheme.breakpoint.small]: {
      maxWidth: 300,
    },
  }),
  otherForms: css({
    display: 'flex',
    flexDirection: 'column',
    gap: mTheme.size.S,
  }),
}

//TO DO: Move to Validate.js once converted to TypeScript
export interface UserSignupFormErrors {
  name?: string
  email?: string
  password?: string
  passwordConfirmation?: string
}

const FanSignupForm: React.FC = () => {
  const userSignup = useUserSignup()
  const [errors, setErrors] = useState<UserSignupFormErrors>({})
  const [submitted, setSubmitted] = useState<boolean>(false)

  const { onSubmit, signupResult } = useOnUserSubmit(
    { userInput: userSignup.state },
    setErrors,
    setSubmitted,
  )

  if (submitted) {
    return (
      <p css={{ textAlign: 'center' }}>
        Please check your email for a verification link.
      </p>
    )
  }

  return (
    <Page title="Fan signup">
      <Card>
        <form css={styles.form} onSubmit={onSubmit}>
          <UserSignupFields
            userSignupState={userSignup}
            errors={errors}
            setErrors={setErrors}
          />
          {userSignup.legalTermsCheckbox}
          <Button
            key={'signup-button-' + userSignup.state.termsAccepted}
            secondary
            css={styles.signupButton}
            disabled={!userSignup.state.termsAccepted || signupResult.loading}
          >
            {signupResult.loading ? 'Signing up...' : 'Sign up'}
          </Button>
          {/* <Spacer y="XXS" /> */}
        </form>
      </Card>
      <div css={styles.otherForms}>
        <span css={styles.footnote}>
          Are you an artist? <Link to="/signup/artist">Create an artist.</Link>
        </span>
        <span css={styles.footnote}>
          Are you a venue manager?{' '}
          <Link to="/signup/venue">Create a venue.</Link>
        </span>
        <span css={styles.footnote}>
          Are you a promoter?{' '}
          <Link to="/signup/promoter">Create a promoter.</Link>
        </span>
      </div>
    </Page>
  )
}

export default FanSignupForm
